
<scroll-area class="work-area workarea">
  <template v-if="objectModelRelations.length">
    <base-object-model-relation
      v-for="objectModelRelation in objectModelRelations"
      :key="objectModelRelation.client_id"
      :object-model-relation="objectModelRelation"
      @remove="removeRelation">
    </base-object-model-relation>
  </template>
  <div v-else class="drop-in-zone empty">
    <p><b>Drag and Drop</b> relationship types here</p>
  </div>
  <template v-if="inverseObjectModelRelations.length">
    <h5>Relationships Defined in Other Object Models</h5>
    <base-object-model-relation
      v-for="relation in inverseObjectModelRelations"
      :key="relation.client_id"
      :object-model-relation="relation"
      disabled
    >
    </base-object-model-relation>
  </template>
</scroll-area>
